export default __webpack_public_path__ + "static/media/xp.3bc23957.png";